import {
  ProductBrandAutocompleteDocument,
  type ProductBrandAutocompleteQuery,
  type ProductBrandAutocompleteQueryVariables,
} from "@/generated/graphql";
import type { AutocompleteFetchResult } from "@k3-tech/react-kit";
import { useCallback } from "react";
import { useClient } from "urql";

export const useProductBrandAutocomplete = () => {
  const urqlClient = useClient();

  const load = useCallback(
    async (page: number, pageSize: number, search: string) => {
      const { data } = await urqlClient
        .query<
          ProductBrandAutocompleteQuery,
          ProductBrandAutocompleteQueryVariables
        >(
          ProductBrandAutocompleteDocument,
          {
            qop: {
              pagination: {
                page,
                pageSize,
                withCount: true,
              },
              filters: { productBrandName: search },
            },
          },
          { suspense: false, requestPolicy: "network-only" },
        )
        .toPromise();

      const rawItems = (data?.productBrands?.items ?? []) as NonNullable<
        ProductBrandAutocompleteQuery["productBrands"]
      >["items"];
      const items = (rawItems || [])
        .filter((it): it is NonNullable<typeof it> => Boolean(it))
        .map((item) => ({ value: item.productBrandID, label: item.productBrandName, raw: item }));

      return {
        items: items ?? [],
        total: data?.productBrands?.pagination?.totalRows ?? 0,
        hasMore: data?.productBrands?.pagination?.hasNext ?? false,
      } as AutocompleteFetchResult;
    },
    [urqlClient],
  );

  return { load };
};
